import { render, staticRenderFns } from "./IndividualExamAnswerOverviewPanel.vue?vue&type=template&id=47195861&scoped=true"
import script from "./IndividualExamAnswerOverviewPanel.vue?vue&type=script&lang=js"
export * from "./IndividualExamAnswerOverviewPanel.vue?vue&type=script&lang=js"
import style0 from "./IndividualExamAnswerOverviewPanel.vue?vue&type=style&index=0&id=47195861&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47195861",
  null
  
)

export default component.exports